import { fetchEscalationData, fetchRegions } from "../../api";
import { Region, applyEscalationData } from "../../interfaces/Region";
import { loadDataIntoSheet } from "../workbook";

export const tabulateRegions = async (): Promise<void> => {
  try {
    const regionsResult = await fetchRegions();
    if (!regionsResult.success) {
      throw regionsResult.error;
    }
    const regions: Region[] = regionsResult.data || [];
    const escalationResult = await fetchEscalationData();
    if (!escalationResult.success) {
      throw escalationResult.error;
    }
    const escalationData = escalationResult.data;
    const updatedRegions = applyEscalationData(escalationData, regions);
    await loadDataIntoSheet(updatedRegions, "Regions", { adminTable: true });
  } catch (error) {
    console.error("Error with Regions ETL:", error);
    throw error;
  }
};
